(function (root, factory) {
  var api = factory(root)

  if (typeof module !== 'undefined' && module.exports) module.exports = api
  root.KarstMegaHeader = api

  if (root.document) {
    root.document.addEventListener('DOMContentLoaded', function () {
      api.init(root.document)
    })
    root.document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('#karst-header')) {
        api.init(root.document)
      }
    })
    root.document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector('#karst-header')) {
        api.destroy(event.target)
      }
    })
  }
})(typeof window === 'undefined' ? globalThis : window, function (host) {
  var controllers = []

  function nextTabIndex(index, key, length) {
    if (!length) return -1
    var delta = key === 'ArrowRight' ? 1 : -1
    return (index + delta + length) % length
  }

  function headerWithin(root) {
    if (!root) return null
    if (root.id === 'karst-header') return root
    return root.querySelector ? root.querySelector('#karst-header') : null
  }

  function destroy(root) {
    var header = headerWithin(root)
    controllers.slice().forEach(function (controller) {
      if (!root || controller.header === header || controller.documentRoot === root) controller.destroy()
    })
  }

  function init(documentRoot) {
    if (!documentRoot || !documentRoot.querySelectorAll) return null
    var header = headerWithin(documentRoot)
    if (!header) return null

    var existing = controllers.find(function (controller) {
      return controller.header === header
    })
    if (existing) return existing

    controllers.slice().forEach(function (controller) {
      if (controller.documentRoot === documentRoot) controller.destroy()
    })

    var removers = []
    var destroyed = false
    var triggers = Array.from(documentRoot.querySelectorAll('[data-category-key]'))
    var panels = Array.from(documentRoot.querySelectorAll('[data-mega-panel]'))
    var mobileTabs = Array.from(documentRoot.querySelectorAll('[data-mobile-tab]'))
    var mobilePanels = Array.from(documentRoot.querySelectorAll('[data-mobile-panel]'))
    var bar = documentRoot.querySelector('.karst-mh__bar')
    var indicator = documentRoot.querySelector('#karstMhInd')
    var utilities = documentRoot.querySelector('.karst-mh__utils')
    var scrim = documentRoot.querySelector('#karstMhScrim')
    var drawer = documentRoot.querySelector('#karstMhDrawer')
    var tabs = documentRoot.querySelector('#karstMhTabs')
    var menuButton = documentRoot.querySelector('#karstMhMenuBtn')
    var closeButton = documentRoot.querySelector('#karstMhCloseBtn')
    var openKey = null
    var activeMobileKey = null
    var openTimer
    var closeTimer
    var previousBodyOverflow = null

    function listen(target, type, listener) {
      if (!target || !target.addEventListener) return
      target.addEventListener(type, listener)
      removers.push(function () {
        if (target.removeEventListener) target.removeEventListener(type, listener)
      })
    }

    function triggerFor(key) {
      return triggers.find(function (trigger) {
        return trigger.dataset.categoryKey === key
      })
    }

    function panelFor(key) {
      return panels.find(function (panel) {
        return panel.dataset.megaPanel === key
      })
    }

    function mobileTabFor(key) {
      return mobileTabs.find(function (tab) {
        return tab.dataset.mobileTab === key
      })
    }

    function moveIndicator(trigger) {
      if (!indicator) return
      if (!trigger || !bar) {
        indicator.classList.remove('on')
        return
      }

      var barRect = bar.getBoundingClientRect()
      var triggerRect = trigger.getBoundingClientRect()
      indicator.style.left = (triggerRect.left - barRect.left - 6) + 'px'
      indicator.style.width = (triggerRect.width + 12) + 'px'
      indicator.classList.add('on')
    }

    function closeDesktop() {
      openKey = null
      panels.forEach(function (panel) {
        panel.classList.remove('open')
        panel.setAttribute('aria-hidden', 'true')
      })
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false')
      })
      if (scrim) scrim.classList.remove('on')
      moveIndicator(null)
    }

    function openDesktop(key) {
      var panel = panelFor(key)
      var trigger = triggerFor(key)
      if (!panel || !trigger) return

      host.clearTimeout(closeTimer)
      openKey = key
      panels.forEach(function (candidate) {
        var isActive = candidate === panel
        candidate.classList[isActive ? 'add' : 'remove']('open')
        candidate.setAttribute('aria-hidden', String(!isActive))
      })
      triggers.forEach(function (candidate) {
        candidate.setAttribute('aria-expanded', String(candidate === trigger))
      })
      if (scrim) scrim.classList.add('on')
      moveIndicator(trigger)
    }

    function placeMobileIndicator() {
      if (!tabs || !activeMobileKey) return
      var tab = mobileTabFor(activeMobileKey)
      var mobileIndicator = documentRoot.querySelector('#karstMhMind')
      if (!tab || !mobileIndicator || !tab.offsetWidth) return
      mobileIndicator.style.left = (tab.offsetLeft - 6) + 'px'
      mobileIndicator.style.width = (tab.offsetWidth + 12) + 'px'
    }

    function activateMobile(key) {
      var activeTab = mobileTabFor(key)
      var activePanel = mobilePanels.find(function (panel) {
        return panel.dataset.mobilePanel === key
      })
      if (!activeTab || !activePanel) return

      activeMobileKey = key
      mobileTabs.forEach(function (tab) {
        var isActive = tab === activeTab
        tab.setAttribute('aria-selected', String(isActive))
        tab.tabIndex = isActive ? 0 : -1
      })
      mobilePanels.forEach(function (panel) {
        var isActive = panel === activePanel
        if (isActive) panel.removeAttribute('hidden')
        else panel.setAttribute('hidden', '')
      })
      placeMobileIndicator()

      var leftEdge = activeTab.offsetLeft - 16
      var rightEdge = activeTab.offsetLeft + activeTab.offsetWidth + 40
      if (tabs) {
        if (leftEdge < tabs.scrollLeft) tabs.scrollLeft = leftEdge
        else if (rightEdge > tabs.scrollLeft + tabs.clientWidth) tabs.scrollLeft = rightEdge - tabs.clientWidth
      }
    }

    function openDrawer() {
      if (!drawer || !menuButton) return
      drawer.scrollTop = 0
      drawer.classList.add('open')
      menuButton.setAttribute('aria-expanded', 'true')
      if (documentRoot.body) {
        if (previousBodyOverflow === null) previousBodyOverflow = documentRoot.body.style.overflow || ''
        documentRoot.body.style.overflow = 'hidden'
      }
      if (host.requestAnimationFrame) host.requestAnimationFrame(placeMobileIndicator)
      host.setTimeout(function () {
        if (closeButton) closeButton.focus()
      }, 50)
    }

    function closeDrawer(restoreFocus) {
      var wasOpen = drawer && drawer.classList.contains('open')
      if (drawer) drawer.classList.remove('open')
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false')
      if (documentRoot.body && previousBodyOverflow !== null) {
        documentRoot.body.style.overflow = previousBodyOverflow
      }
      previousBodyOverflow = null
      if (restoreFocus !== false && wasOpen && menuButton) menuButton.focus()
    }

    triggers.forEach(function (trigger) {
      listen(trigger, 'mouseover', function () {
        host.clearTimeout(openTimer)
        moveIndicator(trigger)
        openTimer = host.setTimeout(function () {
          openDesktop(trigger.dataset.categoryKey)
        }, openKey ? 0 : 90)
      })
      listen(trigger, 'click', function () {
        var key = trigger.dataset.categoryKey
        var panel = panelFor(key)
        if (openKey === key && panel && panel.classList.contains('open')) closeDesktop()
        else openDesktop(key)
      })
      listen(trigger, 'focus', function () {
        moveIndicator(trigger)
      })
    })

    mobileTabs.forEach(function (tab) {
      listen(tab, 'click', function () {
        activateMobile(tab.dataset.mobileTab)
      })
      listen(tab, 'keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return
        event.preventDefault()
        var currentIndex = mobileTabs.indexOf(tab)
        var nextIndex = nextTabIndex(currentIndex, event.key, mobileTabs.length)
        var nextTab = mobileTabs[nextIndex]
        activateMobile(nextTab.dataset.mobileTab)
        nextTab.focus()
      })
    })

    listen(header, 'mouseleave', function () {
      host.clearTimeout(openTimer)
      closeTimer = host.setTimeout(closeDesktop, 160)
    })
    listen(header, 'mouseenter', function () {
      host.clearTimeout(closeTimer)
    })
    listen(utilities, 'mouseenter', function () {
      host.clearTimeout(openTimer)
      closeTimer = host.setTimeout(closeDesktop, 120)
    })
    listen(scrim, 'click', closeDesktop)
    listen(menuButton, 'click', openDrawer)
    listen(closeButton, 'click', closeDrawer)
    listen(documentRoot, 'keydown', function (event) {
      if (event.key !== 'Escape') return
      closeDesktop()
      closeDrawer()
    })
    listen(host, 'resize', function () {
      if (openKey) moveIndicator(triggerFor(openKey))
      placeMobileIndicator()
    })

    var controller = {
      documentRoot: documentRoot,
      header: header,
      destroy: function () {
        if (destroyed) return
        destroyed = true
        host.clearTimeout(openTimer)
        host.clearTimeout(closeTimer)
        closeDesktop()
        closeDrawer(false)
        removers.reverse().forEach(function (remove) { remove() })
        var index = controllers.indexOf(controller)
        if (index >= 0) controllers.splice(index, 1)
      },
    }
    controllers.push(controller)

    var selectedMobileTab = mobileTabs.find(function (tab) {
      return tab.getAttribute('aria-selected') === 'true'
    }) || mobileTabs[0]
    if (selectedMobileTab) activateMobile(selectedMobileTab.dataset.mobileTab)
    return controller
  }

  return {destroy: destroy, init: init, nextTabIndex: nextTabIndex}
})
